import { createI18n } from 'vue-i18n'
import en from '@/locales/en.json'
import ar from '@/locales/ar.json'
import fr from '@/locales/fr.json'
const i18n = createI18n({
    locale: 'ar',
    legacy: false,
    allowComposition: true,
    globalInjection: true,
    messages: {
      'en': en,
      'ar': ar,
      'fr': fr,
    }
})
export default i18n



// const _i18n = new VueI18n({
//     locale: 'en',
//     fallbackLocale: 'ar',
//     messages: loadLocaleMessages()
// });
// window.i18n = _i18n;
// export default  _i18n
